import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import About from "./pages/About";
import Products from "./pages/Products";
import Collection from "./pages/Collection";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import FreeEstimate from "./pages/FreeEstimate";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/about-us" element={<About />} />
          
          {/* Product category routes */}
          <Route path="/products/hardwood" element={<Products />} />
          <Route path="/products/vinyl" element={<Products />} />
          <Route path="/products/carpet" element={<Products />} />
          <Route path="/products/tile" element={<Products />} />
          <Route path="/products/laminate" element={<Products />} />
          
          {/* Collection-specific routes */}
          <Route path="/products/hardwood/solo-collection" element={<Collection />} />
          <Route path="/products/hardwood/canto-collection" element={<Collection />} />
          <Route path="/products/vinyl/evo-collection" element={<Collection />} />
          <Route path="/products/carpet/echo-collection" element={<Collection />} />
          <Route path="/products/carpet/verso-collection" element={<Collection />} />
          <Route path="/products/laminate/novo-collection" element={<Collection />} />
          <Route path="/products/tile/flow-collection" element={<Collection />} />
          <Route path="/products/tile/hydro-collection" element={<Collection />} />
          
          {/* Legacy route for backwards compatibility */}
          <Route path="/products/:category" element={<Products />} />
          <Route path="/products/:category/:collection" element={<Collection />} />
          
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/free-estimate" element={<FreeEstimate />} />
          
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
